import { Link } from "react-router-dom";
import Logo from "./Logo";
import { Mail, Phone, MapPin, Heart } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-[#070C16]">
      <div className="container-x py-16 grid gap-10 lg:grid-cols-12">
        <div className="lg:col-span-4 space-y-4">
          <Logo size={36} wordmarkClassName="text-lg" />
          <p className="text-sm text-white/60 leading-relaxed max-w-sm">
            Enterprise-grade IT services & infrastructure solutions. Servers, cloud, web & mobile development, SEO and on-site hardware repair — built for businesses that can&apos;t stop.
          </p>
          <div className="flex gap-2 pt-2">
            <span className="rounded-full bg-emerald-500/10 border border-emerald-500/30 px-3 py-1 text-xs font-semibold text-emerald-300">ISO Ready</span>
            <span className="rounded-full bg-blue-500/10 border border-blue-500/30 px-3 py-1 text-xs font-semibold text-blue-300">24/7 NOC</span>
          </div>
        </div>

        <div className="lg:col-span-2">
          <h4 className="text-sm font-semibold text-white mb-4">Services</h4>
          <ul className="space-y-2 text-sm text-white/60">
            <li><Link to="/services/web-development" className="hover:text-white" data-testid="footer-svc-web">Web Development</Link></li>
            <li><Link to="/services/android-development" className="hover:text-white" data-testid="footer-svc-android">Android Apps</Link></li>
            <li><Link to="/services/server-management" className="hover:text-white" data-testid="footer-svc-server">Server Management</Link></li>
            <li><Link to="/services/seo" className="hover:text-white" data-testid="footer-svc-seo">SEO Services</Link></li>
            <li><Link to="/services/hardware-repair" className="hover:text-white" data-testid="footer-svc-hw">Hardware Repair</Link></li>
          </ul>
        </div>

        <div className="lg:col-span-2">
          <h4 className="text-sm font-semibold text-white mb-4">Company</h4>
          <ul className="space-y-2 text-sm text-white/60">
            <li><Link to="/about" className="hover:text-white" data-testid="footer-about">About</Link></li>
            <li><Link to="/pricing" className="hover:text-white" data-testid="footer-pricing">Pricing</Link></li>
            <li><Link to="/request" className="hover:text-white" data-testid="footer-request">Request Service</Link></li>
            <li><Link to="/contact" className="hover:text-white" data-testid="footer-contact">Contact</Link></li>
            <li><Link to="/login" className="hover:text-white" data-testid="footer-login">Client Login</Link></li>
          </ul>
        </div>

        <div className="lg:col-span-2">
          <h4 className="text-sm font-semibold text-white mb-4">Legal</h4>
          <ul className="space-y-2 text-sm text-white/60">
            <li><Link to="/terms" className="hover:text-white" data-testid="footer-terms">Terms &amp; Conditions</Link></li>
            <li><Link to="/agreement" className="hover:text-white" data-testid="footer-agreement">User Agreement</Link></li>
            <li><Link to="/privacy" className="hover:text-white" data-testid="footer-privacy">Privacy Policy</Link></li>
            <li><Link to="/refund" className="hover:text-white" data-testid="footer-refund">Refund &amp; Cancellation</Link></li>
          </ul>
        </div>

        <div className="lg:col-span-2">
          <h4 className="text-sm font-semibold text-white mb-4">24/7 Helpline</h4>
          <ul className="space-y-3 text-sm text-white/70">
            <li className="flex items-start gap-3"><Phone className="h-4 w-4 mt-0.5 text-blue-400 shrink-0" /><a href="tel:+918055592955" className="hover:text-white" data-testid="footer-phone">+91 80555 92955 <span className="block text-xs text-white/40">Yadav Bawane · 24×7</span></a></li>
            <li className="flex items-start gap-3"><Mail className="h-4 w-4 mt-0.5 text-blue-400 shrink-0" /><span className="break-all">support@uidinfotech.online</span></li>
            <li className="flex items-start gap-3"><MapPin className="h-4 w-4 mt-0.5 text-blue-400 shrink-0" /><span>India · serving clients globally</span></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="container-x py-6 flex flex-col items-center justify-center gap-1.5 text-center text-xs text-white/50" data-testid="footer-copyright-bar">
          <p data-testid="footer-copyright">© 2026 All Rights Reserved by UID Infotech.</p>
          <p className="inline-flex items-center gap-1.5">
            Developed with <Heart className="h-3 w-3 text-rose-400 fill-rose-400" /> by
            <span className="font-semibold text-white/75" data-testid="footer-developer">Yadav Bawane</span>.
          </p>
        </div>
      </div>
    </footer>
  );
}
